import { FETCH_STATS_COLUMNS, FETCH_STATS, STATS_LOADING } from "../actions";

export function statsColumns(state = [], action = {}) {
    return action.type === FETCH_STATS_COLUMNS ? action.payload : state;
}

export function stats(state = [], action = {}) {
    return action.type === FETCH_STATS ? action.payload : state;
}

export function statsLoading(state = false, action = {}){
    return action.type === STATS_LOADING ? action.payload : state;
}




// WEBPACK FOOTER //
// ./src/reducers/reducers-stats.js